export default {
  data() {
    return {
      selectedReservationStatus1: []
    };
  },
  methods: {
    onChangeReservationStatus() {
      let ids = this.selectedReservationStatus1?.map(item => item.id) ?? [];
      this.filters.zz_reservation_status_1_id = ids;
      this.getData();
    },
    checkedReservationStatus(option) {
      return this.selectedReservationStatus1.some(item => item.id == option.id);
    },
    checkedAllReservationStatus() {
      return (
        this.selectedReservationStatus1.length ==
        this.zzReservationStatus1[0].attributes.length
      );
    }
  },
  computed: {
    zzReservationStatus1() {
      let options = [
        {
          selectAll: "すべて",
          attributes: this.$store.getters["options/options_tables"].zz_reservation_status_1 ?? []
        }
      ];

      return options;
    }
  }
};
  